import { communityAmbassadorData } from '@/app/[locale]/(landing-page)/dai-su-the-thao/_data/community-ambassador-data'
import { sportsAmbassadorData } from '@/app/[locale]/(landing-page)/dai-su-the-thao/_data/sports-ambassador-data'

// c) Câu Lạc Bộ Chiến Lược
export const STRATEGIC_CLUBS_DATA = [
  {
    id: 1,
    name: 'Hà Đông Runners',
    location: 'Hà Nội',
    image: '/image/2026/03/09/DlrtbFKFKoTbHMxovP4lDf78gxd.jpg',
  },
  {
    id: 2,
    name: 'Hưng Yên Runners',
    location: 'Hưng Yên',
    image: '/image/2026/03/30/image_1774859917454.jpg',
  },
  {
    id: 3,
    name: 'Vinhomes Ocean Park Runners',
    location: 'Hà Nội',
    image: '/image/2026/03/09/Dc4jbXMNyo7tHAxlv8XlZBpMgSv.jpg',
  },
  {
    id: 4,
    name: 'Hải Châu Runners',
    location: 'Đà Nẵng',
    image: '/image/2026/03/09/XdKBbEJ0joCN8FxxcoplybbKgVd.jpg',
  },
  {
    id: 5,
    name: 'IAMV RUN',
    location: 'Toàn Quốc',
    image: '/image/2026/03/09/FOF4b69xWoy6DNxri8JlV2VKgzu.jpg',
  },
  {
    id: 6,
    name: 'Phú Mỹ Hưng Runners',
    location: 'Hồ Chí Minh',
    image: '/image/2026/03/09/B8IAbnzD1oGUaCxMfEWl6cFIgqd.jpg',
  },
  {
    id: 7,
    name: 'Tháp Mười Runners',
    location: 'Đồng Tháp',
    image: '/image/2026/03/09/EEP3ber8qoV1XZxji3UloyZLgzb.jpg',
  },
  {
    id: 8,
    name: 'The Hanoi Run Club',
    location: 'Hà Nội',
    image: '/image/2026/03/09/JxgobyX2xo6ssuxvm7vlRon2gpd.jpg',
  },
  {
    id: 9,
    name: 'AG Crew',
    location: 'Hà Nội',
    image: '/image/2026/03/09/VC3Yb0UfEoiEZ9xFMDMlRUPcgmf.jpg',
  },
  {
    id: 10,
    name: 'Runmatic',
    location: 'Hồ Chí Minh',
    image: '/image/2026/03/09/FhjEbqQnQoV7F4xU4hel4bdygLg.jpg',
  },
  {
    id: 11,
    name: 'Hamchoi',
    location: 'Hồ Chí Minh',
    image: '/image/2026/03/09/ZUbXbKTzwoeckIxSbExluWFUgkh.jpg',
  },
  {
    id: 12,
    name: 'CLB Pickleball Vua Bếp',
    location: '',
    image: '/image/2026/03/09/HUkMbUFXAo1vVPxTlqqlZ6Xoggc_73.jpg',
  },
  {
    id: 13,
    name: 'CLB Pickleball Hunter',
    location: '',
    image: '/image/2026/03/09/XeqibcBCMoubeDxDfZllA5zkgke.jpg',
  },
  {
    id: 14,
    name: 'CLB Pickleball Coolmate Đà Nẵng',
    location: '',
    image: '/image/2026/03/09/NIPAbvM9VopZ5kx9h5al8pbagwd.jpg',
  },
] as const

// d) Câu Lạc Bộ Bạn Đồng Hành
export const COMPANION_CLUBS_DATA = [
  {
    id: 1,
    name: 'Cầu Giấy Park Runners',
    image: '/image/2026/03/09/KMx8bGGCzoT20bxbrSNl61Vkgsb.jpg',
  },
  {
    id: 2,
    name: 'Cẩm Phả Runners',
    image: '/image/2026/03/09/IMWqbnIv8opNYCxMK7slc1lGgRg.jpg',
  },
  {
    id: 3,
    name: 'Đông Anh Runners',
    image: '/image/2026/03/09/Hvv1bZPlYok9Dgxmg1TlWpZJg8f.jpg',
  },
] as const

export const AMBASSADORS_DATA = [
  {
    id: 'ca-nhan',
    tabName: 'CÁ NHÂN ĐỒNG HÀNH',
    hero: {
      tag: 'BẠN ĐỒNG HÀNH & AFFILIATE',
      title:
        'KHÔNG PHẢI AI CŨNG BẮT ĐẦU HOÀN HẢO — NHƯNG AI CŨNG CÓ THỂ BẮT ĐẦU',
      description: [
        'Những người đồng hành cùng Coolmate là những con người thật — với hành trình riêng, những lần vấp ngã, và cả những khoảnh khắc vượt qua giới hạn của chính mình.',
        'Họ không chỉ vận động cho bản thân, mà còn kết nối, chia sẻ và lan tỏa động lực đến cộng đồng.',
        'Bởi đôi khi, điều khiến chúng ta tiếp tục không phải là thành tích, mà là việc nhìn thấy một người giống mình đã dám bắt đầu.',
        'Bạn có sẵn sàng chia sẻ hành trình của mình một cách chân thật?',
      ],
      buttonText: 'ĐĂNG KÝ ĐỒNG HÀNH →',
      href: 'https://coolmateme.sg.larksuite.com/share/base/form/shrlgp0FFHje3AOQBTQlZBhFQfe',
      image: '/image/2026/03/23/Rectangle_354.png',
    },
    middleSection: {
      type: 'ambassadors',
      title: 'GẶP GỠ ĐẠI SỨ & BẠN ĐỒNG HÀNH',
      items: [
        ...sportsAmbassadorData.map((a) => ({
          tag: 'ĐẠI SỨ',
          name: a.name,
          role: a.profession,
          image: a.images?.[0] || '/image/2026/03/23/Rectangle_354.png',
          modalData: a,
        })),
        ...communityAmbassadorData.map((a) => ({
          tag: '',
          name: a.name ? `landing_dai_su_the_thao_page.${a.name}` : '',
          role: a.profession
            ? `landing_dai_su_the_thao_page.${a.profession}`
            : '',
          image: a.image,
          modalData: {
            name: a.name ? `landing_dai_su_the_thao_page.${a.name}` : '',
            profession: a.profession
              ? `landing_dai_su_the_thao_page.${a.profession}`
              : '',
            achievement:
              a.achievement?.map(
                (ach) => `landing_dai_su_the_thao_page.${ach}`
              ) || [],
            images: [a.image],
            quote: a.quote ? `landing_dai_su_the_thao_page.${a.quote}` : '',
          },
        })),
      ],
    },
    bottomSection: {
      title: 'NHỮNG ĐIỀU CHÚNG TÔI LÀM CÙNG NHAU',
      hasFilter: false,
      items: [
        {
          tag: '03.2026',
          title: 'VPBank International Marathon - 26/10/2025',
          image: '/image/2026/03/23/Rectangle_354.png',
          modalData: {
            title: 'VPBank International Marathon - 26/10/2025',
            images: [
              '/image/2026/03/23/Rectangle_354.png',
              '/image/2026/03/23/Rectangle_354.png',
              '/image/2026/03/23/Rectangle_354.png',
            ],
            content: [
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
              '<blockquote>hihihihihihihihihi</blockquote>',
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
            ],
          },
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
      ],
    },
  },
  {
    id: 'cau-lac-bo',
    tabName: 'CÂU LẠC BỘ ĐỒNG HÀNH',
    hero: {
      tag: 'CÂU LẠC BỘ ĐỒNG HÀNH',
      title: 'NHỮNG CỘNG ĐỒNG TẠO NÊN THAY ĐỔI',
      description: [
        'Các câu lạc bộ đồng hành cùng Coolmate không chỉ là nơi rèn luyện thể chất.',
        'Đó là nơi con người gặp gỡ, kết nối và xây dựng những giá trị tích cực cho thể thao Việt Nam — nơi người mới được chào đón, người chơi lâu năm được tiếp thêm năng lượng, và tinh thần thể thao được lan tỏa vượt ra ngoài sân chơi.',
        'Chúng tôi tin rằng một cộng đồng khỏe mạnh sẽ tạo nên một xã hội khỏe mạnh.',
      ],
      buttonText: 'ĐĂNG KÝ ĐỒNG HÀNH →',
      href: 'https://coolmateme.sg.larksuite.com/share/base/form/shrlg3YzRrGKC1R9H5k45Vt0Erc',
      image: '/image/2026/03/30/Rectangle_354_1.png',
    },
    middleSection: {
      type: 'communities',
      title: 'NHỮNG CỘNG ĐỒNG ĐANG CÙNG COOLMATE TẠO NÊN THAY ĐỔI',
      items: [...STRATEGIC_CLUBS_DATA, ...COMPANION_CLUBS_DATA],
    },
    bottomSection: {
      title: 'NHỮNG ĐIỀU CHÚNG TÔI LÀM CÙNG NHAU',
      hasFilter: true,
      filters: ['Running', 'Pickleball', 'Khác'],
      items: [
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
      ],
    },
  },
  {
    id: 'don-vi',
    tabName: 'ĐƠN VỊ / TỔ CHỨC ĐỒNG HÀNH',
    hero: {
      tag: 'ĐƠN VỊ/TỔ CHỨC ĐỒNG HÀNH',
      title: 'MỖI SỰ KIỆN LÀ MỘT CƠ HỘI TRUYỀN CẢM HỨNG',
      description: [
        'Đằng sau mỗi sự kiện không chỉ là một chương trình, mà là sự đồng hành của những đơn vị cùng chung tầm nhìn. Cùng Coolmate, họ tạo nên những không gian nơi con người được kết nối, trải nghiệm được mở rộng và cảm hứng được lan tỏa mạnh mẽ hơn qua từng hoạt động.',
        'Bởi mỗi sự kiện, nếu được tạo nên đúng cách, đều có thể trở thành một dấu ấn — và là nơi những giá trị thật được hình thành.',
      ],
      buttonText: 'ĐĂNG KÝ ĐỒNG HÀNH →',
      href: 'https://coolmateme.sg.larksuite.com/share/base/form/shrlgGpM5tlYEtLGT5IiE56M0Dh',
      image: '/image/2026/03/30/Rectangle_354.png',
    },
    middleSection: {
      type: 'organizations',
      title: 'CÁC ĐƠN VỊ ĐỒNG HÀNH CÙNG COOLMATE',
      items: [],
    },
    bottomSection: {
      title: 'NHỮNG HOẠT ĐỘNG CÙNG COOLMATE',
      hasFilter: false,
      items: [
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
        {
          tag: '03.2026',
          title: 'Tittle bài viết',
          image: '/image/2026/03/23/Rectangle_354.png',
        },
      ],
    },
  },
] as const
